export const inspectTable_1 = [
  {
    title: '운전자격',
    content: `운전원의 자격사항 확인`,
    isChecked: ``,
  },
  {
    title: '안전장치',
    content: `후진경보음\n- 후진시 경보음 작동 및 음량 확인`,
    isChecked: ``,
  },
  {
    title: '안전장치',
    content: `헤드가이드\n- 운전자 보호를 위한 헤드가이드 설치 확인`,
    isChecked: ``,
  },
  {
    title: '안전장치',
    content: `후사경, 룸미러\n- 시계확보를 위한 후사경, 룸미러 설치상태 확인`,
    isChecked: ``,
  },
  {
    title: '안전장치',
    content: `백레스트\n- 백레스트 설치 및 고정상태 확인`,
    isChecked: ``,
  },
  {
    title: '안전장치',
    content: `안전벨트\n- 좌석 안전띠 부착여부 및 운전자 착용여부 확인`,
    isChecked: ``,
  },
  {
    title: '표시등',
    content: `각종 표시등 작동상태\n- 전조등, 후미등, 방향지시등, 경광등의 정상작동 확인`,
    isChecked: ``,
  },
  {
    title: '정비상태',
    content: `이상소음\n- 각 작동부 이상소음 / 작동상태 확인`,
    isChecked: ``,
  },
  {
    title: '정비상태',
    content: `유압유/냉각수\n- 각 작동부 유압유 / 냉각수 누설여부 확인`,
    isChecked: ``,
  },
  {
    title: '정비상태',
    content: `타이어 상태\n- 타이어의 마모 / 공기압상태 확인`,
    isChecked: ``,
  },

];

export const inspectTable_2 = [
  {
    title: '운전자격',
    content: `<div><p>운전원 면허자격 여부 / 안전인증 / 안전검사 여부</p>
<table class="temp-table">
    <tr><td>기중기</td><td >건설기계조종사 면허</td></tr>
    <tr><td rowspan="2">카고크레인</td><td>1종 대형먼허(12톤 이상)</td></tr>
    <tr><td>1종 보통면허(12톤 미만)</td></tr>
</table><style>
.temp-table { border-collapse: collapse; }
.temp-table,
 .temp-table td{
    border: 1px solid #cdcdcd;
    text-align: center;
    padding: 4px;
}
</style></div>`,
    isChecked: ``,
  },
  {
    title: '안전장치',
    content: `권과방지장치\n- 권과방지장치, 과부하방지장치, 비상정지장치 등`,
    isChecked: ``,
  },
  {
    title: '안전장치',
    content: `아웃트리거\n- 설치 및 작동상태, 받침목 상태 확인`,
    isChecked: ``,
  },
  {
    title: '안전장치',
    content: `줄걸이류\n- 줄걸이류 상태 확인 및 점검필증 확인\nEx) 후크해지 장치, 시브 블록 등(정격하중),슬링,샤클,턴버클,훅,블록,와이어로프 등`,
    isChecked: ``,
  },
  {
    title: '안전장치',
    content: `탑승설비\n- 미인증 작업대 부착여부(작업대 연결)\nEx) 카고크레인의 작업대 부착 사용 금지`,
    isChecked: ``,
  },
  {
    title: '표시등',
    content: `각종 표시등 작동상태\n- 전조등, 후미등, 방향지시등, 경광등 외 정상작동 확인`,
    isChecked: ``,
  },
  {
    title: '정비상태',
    content: `이상소음\n- 각 작동부 이상소음 / 작동상태 확인\n- 운전석 조작장치 및 제동장치 상태(PTO 연결확인)`,
    isChecked: ``,
  },
  {
    title: '정비상태',
    content: `유압유/냉각수\n- 각 작동부 유압유 / 냉각수 누설여부 확인`,
    isChecked: ``,
  },
  {
    title: '기타',
    content: `크레인 제원표\n- 작업반경/각도 별 인양하중 확인 가능여부\n- 장비자체 정격하중 표시여부`,
    isChecked: ``,
  },
  {
    title: '기타',
    content: `검사증명서\n- 연 1회 이상 관련기관(업체)의 안전검사 여부`,
    isChecked: ``,
  },
  {
    title: '기타',
    content: `안전수칙 준수\n- 유도자 및 신호수 배치여부(작업지휘자)\n- 중량물 취급관련 작업계획서 작성 여부`,
    isChecked: ``,
  },

];

export const inspectTable_3 = [
  {
    title: '운전자격',
    content: `운전원 면허 자격 여부\n(10톤 미만 : 1종 보통면허 / 10톤이상 : 1종 대형면허)`,
    isChecked: ``,
  },
  {
    title: '안전장치',
    content: `비상정지장치\n- 비상정지장치의 작동여부 확인`,
    isChecked: ``,
  },
  {
    title: '안전장치',
    content: `아웃트리거\n- 아웃트리거 근접센서* 작동상태\n*아웃트리거 지면접촉상태 정상 설치 확인장치`,
    isChecked: ``,
  },
  {
    title: '안전장치',
    content: `안전장치 모니터\n- 각종 안전장치 작동 확인(센서값 변화 확인)\n : 과상승방지장치/모멘트 감지장치/탑승함 로드셀/자동 안전장치`,
    isChecked: ``,
  },
  {
    title: '표시등',
    content: `각종 표시등 작동상태\n- 전조등, 후미등, 방향지시등, 경광등의 정상작동 확인`,
    isChecked: ``,
  },
  {
    title: '정비상태',
    content: `이상소음\n- 각 작동부 이상소음 / 작동상태 확인`,
    isChecked: ``,
  },
  {
    title: '정비상태',
    content: `유압유 / 냉각수\n- 각 작동부 유압유 / 냉각수 누설여부 확인`,
    isChecked: ``,
  },
  {
    title: '정비상태',
    content: `작업대\n- 붐대와 작업대의 연결장치 상태 확인\nEx) 볼트의 이완여부 등`,
    isChecked: ``,
  },
  {
    title: '정비상태',
    content: `와이어로프\n- 소선의 파단여부, 단말처리 상태 확인`,
    isChecked: ``,
  },
  {
    title: '기타',
    content: `검사증명서\n - 안전인증(KCs) 표시 및 안전검사(차량탑재형) 확인\n* '09.7.1 이후 출고 기준(안전인증), '16. 8월 안전검사 시행 `,
    isChecked: ``,
  },
  {
    title: '기타',
    content: `안전수칙\n- 유도자 및 신호수 배치여부(작업지휘자)`,
    isChecked: ``,
  },
  {
    title: '기타',
    content: `안전수칙\n- 중량물 취급관련 작업계획서 작성 여부`,
    isChecked: ``,
  },

];

export const inspectTable_4 = [
  {
    title: '운전자격',
    content: `비상정지장치\n- 비상정지 장치의 작동여부 확인`,
    isChecked: ``,
  },
  {
    title: '안전장치',
    content: `발끝막이 판\n- 작업대 하부 공구 추락 방지시설 설치여부`,
    isChecked: ``,
  },
  {
    title: '안전장치',
    content: `주행차단 장치\n- 작업대 상승상태에서 주행가능 여부 확인`,
    isChecked: ``,
  },
  {
    title: '안전장치',
    content: `과상승 방지장치\n- 난간대 위 60cm, 2개소 이상 설치여부 및 작동확인`,
    isChecked: ``,
  },
  {
    title: '표시등',
    content: `각종 표시등 작동상태\n- 작동 시 경보 및 경광등 작동 여부`,
    isChecked: ``,
  },
  {
    title: '정비상태',
    content: `이상소음\n- 각 작동부 이상소음 / 작동상태 확인`,
    isChecked: ``,
  },
  {
    title: '정비상태',
    content: `유압유\n- 각 작동부 유압유 누설여부 확인`,
    isChecked: ``,
  },
  {
    title: '정비상태',
    content: `외관상태\n- 고정부 볼트 이완 여부 등 전반적 육안확인`,
    isChecked: ``,
  },
  {
    title: '정비상태',
    content: `조작장치\n- 조작레버 작동상태 및 계기판 / 표시등 상태`,
    isChecked: ``,
  },
  {
    title: '정비상태',
    content: `타이어\n- 타이어 마모 / 공기압 상태 확인`,
    isChecked: ``,
  },
  {
    title: '기타',
    content: `안전수칙\n- 유도자 및 신호수 배치여부(작업지휘자)`,
    isChecked: ``,
  },
  {
    title: '기타',
    content: `안전수칙\n- 중량물 취급관련 작업계획서 작성 여부`,
    isChecked: ``,
  },

];

export const inspectTable_5 = [
  {
    title: '아워메터(hr)',
    content: `주유량 (리터)`,
    isChecked: ``,
  },
  {
    title: '아워메터(hr)',
    content: `붐·크랙마모(여/부)`,
    isChecked: ``,
  },
  {
    title: '아워메터(hr)',
    content: `엔진오일량`,
    isChecked: ``,
  },
  {
    title: '아워메터(hr)',
    content: `작동유탱크유량`,
    isChecked: ``,
  },
  {
    title: '아워메터(hr)',
    content: `모니터(알람)확인`,
    isChecked: ``,
  },
  {
    title: '아워메터(hr)',
    content: `라디에터냉각수량`,
    isChecked: ``,
  },
  {
    title: '아워메터(hr)',
    content: `벨트장력 및 손상`,
    isChecked: ``,
  },
  {
    title: '아워메터(hr)',
    content: `연료량 및 필터(수분, 침전물)`,
    isChecked: ``,
  },
  {
    title: '아워메터(hr)',
    content: `각 부위(핀마모)`,
    isChecked: ``,
  },
  {
    title: '아워메터(hr)',
    content: `그리스주입(여/부)`,
    isChecked: ``,
  },
  {
    title: '아워메터(hr)',
    content: `그라플·크랙마모(여/부)`,
    isChecked: ``,
  },
  {
    title: '아워메터(hr)',
    content: `유압호스 누유상태`,
    isChecked: ``,
  },
  {
    title: '아워메터(hr)',
    content: `후방카메라 정상작동 확인`,
    isChecked: ``,
  },

];
